document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.toggle-section .toggle-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var next = trigger.nextElementSibling;
      if (next) {
        next.classList.toggle('is-open');
      }
    });
  });
});
